import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IOption, IColumn } from '../../../../core/models/ty-table.model';

@Component({
    selector: 'lynkd-pattern-ty-plan-table',
    templateUrl: './ty-plan-table.component.html',
    styleUrls: ['./ty-plan-table.component.scss']
})
export class TyPlanTableComponent {
    public get data(): Array<IOption> {
        return this._data;
    }

    @Input()
    public set data(value: Array<IOption>) {
        this._data = value;
    }

    public editId: number | null = null;
    public editColumn: string | null = null;

    @Input()
    public set loading(data: boolean) {
        if (data) {
            this._loading = data;
            return;
        }

        this._loading = false;
    }

    public get loading(): boolean {
        return this._loading;
    }

    @Input()
    public set columns(data: Array<IColumn>) {
        if (data !== null && data !== undefined) {
            this._columns = data.sort((a: IColumn, b: IColumn) => a.order - b.order);
        }
    }

    public get columns(): Array<IColumn> {
        return this._columns;
    }

    @Input()
    public selectedSeason: string;

    @Input()
    public selectedAttributeValue: string;

    @Input()
    public totals: IOption;

    @Output()
    public readonly state: EventEmitter<{allOptions: Array<IOption>, updatedOption: IOption}> = new EventEmitter();

    private _columns: Array<IColumn>;
    private _loading: boolean;
    private _data: Array<IOption>;

    public startEdit(rowIndex: number, columnName: string): void {
        if (this.selectedAttributeValue !== 'ALL') {
            this.editId = rowIndex;
            this.editColumn = columnName;
        }
    }

    public isEditable(rowIndex: number, columnName: string): boolean {
        const editableColumns: Array<string> = ['sku_plan', 'moq', 'mark_up'];
        return this.selectedAttributeValue !== 'ALL' &&
               editableColumns.includes(columnName) &&
               this.editId === rowIndex && this.editColumn === columnName;
    }

    public async stopEdit(index: number, sku_plan: number): Promise<void> {
        if (!sku_plan) {
            this.editId = null;
            this.editColumn = null;
        } else {
            this.editId = null;
            this.editColumn = null;
            this.state.emit({allOptions: this._data, updatedOption: this._data[index]});
        }
    }

    public getColumnTotal(columnName: string): number {
        if (!this.totals) {
            return 0;
        }

        // Calculate average for mark_up column
        if (columnName === 'mark_up') {
            let count: number = 0;
            let total: number = 0;

            for (const row of this._data) {
                if (row[columnName]) {
                    total += row[columnName];
                    count++;
                }
            }

            return count > 0 ? total / count : 0;
        }

        return this.totals[columnName];
    }

    public roundToTwoDecimals(num: number): number {
        if (isNaN(num)) {
            return Math.round((Number(num) + Number.EPSILON) * 100) / 100;
        }

        return Math.round((num + Number.EPSILON) * 100) / 100;
    }

    // Get CSS class for editable columns
    public getColumnClass(columnName: string): string {
        const editableColumns: Array<string> = ['sku_plan', 'moq', 'mark_up'];
        return this.selectedAttributeValue !== 'ALL' && editableColumns.includes(columnName)
            ? 'editable-cell dynamic-column'
            : 'readonly-column';
    }
}
